// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"678":"2079d1171f6c5400742f","682":"0dbe43980fd8726e0e92"}[chunkId] + ".js";
};